import styled from './styled';
export default styled;
